<!-- 地图 -->
<style lang="stylus" scoped>
.center
  height 100%
  padding 5px
  background-size 100% 100%
  .describe
    display flex
    justify-content space-between
    color #fff
    text-align center
    margin-top 3vh
    margin-bottom 2vh
    padding 20px
    .left, .right
      width 50%
    .title
      // width: 14.3vh;
      height 4.2vh
      line-height 4.2vh
      // margin: 2vh auto;
      // font-size: 1.8vh;
      // font-weight: bold;
      font-size 24px
      font-weight 400
      color rgba(255, 255, 255, 1)
    .number2
      height 33px
      font-size 36px
      font-weight 400
      color rgba(1, 255, 246, 1)
      line-height 28px
      text-align center
      height 4.2vh
      line-height 4.2vh
    .number1
      height 33px
      font-size 36px
      font-weight 400
      color rgba(255, 171, 25, 1)
      line-height 28px
      text-align center
      height 4.2vh
      line-height 4.2vh
    .detail
      display flex
      .item
        width 100%
  .map
    margin-top -50px
    width 810px
    height 624px
    position relative
    // border: 1px solid #FFF;
    margin 0 auto
    background url('../../../../../assets/img/trp/map.png')
    background-size 100% 100%
    .item3
      position absolute
      left 400px
      top 250px
      .mark
        width 22px
        height 30px
        background url('../../../../../assets/img/trp/mark.png')
        background-size 100% 100%
        margin 0 auto
      .tip
        width 297px
        height 158px
        padding 20px
        color #FFF
        background url('../../../../../assets/img/trp/tip.png')
        background-size 100% 100%
    .item2
      position absolute
      left 300px
      top 150px
      .mark
        width 22px
        height 30px
        background url('../../../../../assets/img/trp/mark.png')
        background-size 100% 100%
        margin 0 auto
      .tip
        width 297px
        height 158px
        padding 20px
        color #FFF
        background url('../../../../../assets/img/trp/tip.png')
        background-size 100% 100%
    .item
      position absolute
      left 100px
      top 200px
      .mark
        width 22px
        height 30px
        background url('../../../../../assets/img/trp/mark.png')
        background-size 100% 100%
        margin 0 auto
      .tip
        width 297px
        height 158px
        padding 20px
        color #FFF
        background url('../../../../../assets/img/trp/tip.png')
        background-size 100% 100%
@keyframes warn
  0%
    transform scale(0.3)
    -webkit-transform scale(0.3)
    opacity 0
  25%
    transform scale(0.3)
    -webkit-transform scale(0.3)
    opacity 0.1
  50%
    transform scale(0.5)
    -webkit-transform scale(0.5)
    opacity 0.3
  75%
    transform scale(0.8)
    -webkit-transform scale(0.8)
    opacity 0.5
  100%
    transform scale(1)
    -webkit-transform scale(1)
    opacity 0
@keyframes warn1
  0%
    transform scale(0.3)
    -webkit-transform scale(0.3)
    opacity 0
  25%
    transform scale(0.3)
    -webkit-transform scale(0.3)
    opacity 0.1
  50%
    transform scale(0.3)
    -webkit-transform scale(0.3)
    opacity 0.3
  75%
    transform scale(0.5)
    -webkit-transform scale(0.5)
    opacity 0.5
  100%
    transform scale(0.8)
    -webkit-transform scale(0.8)
    opacity 0
.container
  position relative
  width 120px
  height 120px
  left 100px
  top 190px
.top
  position relative
  width 86px
  height 40px
  left 95px
  top 90px
  font-size 20px
  line-height 35px
  font-weight 400
  text-align right
  padding-right 5px
  color rgba(255, 255, 255, 1)
  background url('../../../../../assets/img/ljc/Shape12.png')
  background-size 100% 100%
  span
    position absolute
    left 5px
    top 5px
    width 25px
    height 22px
    background url('../../../../../assets/img/ljc/people.png')
    background-size 100% 100%
</style>

<template>
  <div>
    <div class="center">

      <!-- <div class="describe">
        <div class="item">
          <div class="title">党员</div>
          <div class="number1">29人</div>
        </div>
        <div class="item">
          <div class="title">本月党员学习</div>
          <div class="number2">5次</div>
        </div>
        <div class="item">
          <div class="title">本月处理村务</div>
          <div class="number1">152项</div>
        </div>
        <div class="item">
          <div class="title">本月发放补贴</div>
          <div class="number2">7304元</div>
        </div>
      </div> -->
      <div class="map">
        <div class="item"
             v-show="list[0]">
          <div class="tip">测试内容1</div>
          <div class="mark"></div>
        </div>
        <div class="item2"
             v-show="list[1]">
          <div class="tip">测试内容222</div>
          <div class="mark"></div>
        </div>
        <div class="item3"
             v-show="list[2]">
          <div class="tip">测试内容333</div>
          <div class="mark"></div>
        </div>
      </div>
      <v-table1></v-table1>
      <v-table2></v-table2>
      <!-- <centerBottom></centerBottom> -->
    </div>
  </div>
</template>

<script>
import countTo from 'vue-count-to';
import config from '../../../../../../static/config/config';
import centerBottom from './centerBottom'
import table1 from '../table1/index'
import table2 from '../table2/index'


export default {
  props: ["productionScale", "outputValue"],
  data () {
    return {
      areaName: '',
      list: [true, false, false],
      timer: null,
      massifList: [],
      massifListR: [],
      tip: true,
      datalist: [],
      typeindex: 0,
      url: config.fileDomain
    }
  },
  components: {
    centerBottom,
    // countTo,
    'v-table1': table1,
    'v-table2': table2
  },
  methods: {
  },
  async mounted () {
    this.time = setInterval(() => {
      this.typeindex = this.typeindex + 1
      // if (this.typeindex > this.) {
      //   this.typeindex = 0
      // }
      this.list.push(this.list.shift())
      // this.changeType(this.list[this.typeindex], this.typeindex)
      // this.$nextTick()
      console.log(this.list)
    }, 3000);
  },
  beforeDestroy () {
  }
}
</script>



// WEBPACK FOOTER //
// index.vue?f2bb64d4